export default {

	props: {
		/** 图片路径 */
		src: {
			type: String,
			required: true
		},

		/**
		 * 图片比率
		 *
		 * 'x:y'
		 */
		ratio: {
			type: String,
			required: true
		},

		/** 图片宽度 */
		width: {
			type: [String, Number],
			required: true
		},

		/** 图片内部尺寸(裁剪) */
		size: {
			type: [String, Number]
		},

		/** 外边距 */
		margin: {
			type: String
		},

		/** 内边距 */
		padding: {
			type: String
		},
	},


	computed: {
		height: (vm)  => {
			const width = typeof vm.width === 'string'
				? vm.width
				: `${ vm.width }px`
			;

			const ratio = vm.ratio;


			const matchs = width.match(/^((\d+)?\.?\d+)(.+)$/);

			if (matchs === null) {
				return '0';
			}

			const width_number = Number(matchs[1]) || 0;
			const width_unit = matchs[3] || '';
			const [ratio_x, ratio_y] = ratio.split(':').map((ratio_value) => {
				return Number(ratio_value);
			});

			return `${ width_number * (ratio_y / ratio_x) }${ width_unit }`;
		}
	}

}
